import { render, staticRenderFns } from "./CreateProductForm.vue?vue&type=template&id=3403b247"
import script from "./CreateProductForm.vue?vue&type=script&lang=js"
export * from "./CreateProductForm.vue?vue&type=script&lang=js"
import style0 from "./CreateProductForm.vue?vue&type=style&index=0&id=3403b247&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports